// @flow
import { Base } from '@gandi/ui';

import styles from './RestrictionBlock.scss';

type Props = {
  fqdn: string,
  restriction: string,
};

export function RestrictionBlock({
  fqdn,
  restriction,
}: Props): React.MixedElement {
  return (
    <div id={`${fqdn}-restriction-block`} className={styles.root}>
      <Base
        margin="none"
        color="weak"
        dangerouslySetInnerHTML={{ __html: restriction }}
      />
    </div>
  );
}
